import React, { useRef, useState } from "react";
import {
  Box,
  Input,
  Text,
  Button,
  Flex,
  useToast,
  List,
  ListItem,
} from "@chakra-ui/react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar";
import { modules, formats } from "../../utils/quillModules"; // wherever you saved it
import * as mod from "../../url";
const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
const token = storedData?.data?.token;
const SIDEBAR_WIDTH = "250px";
const draftTypes = [
  "Agreements & Contracts",
  "Corporate & Commercial Law",
  "Litigation & Dispute Resolution",
  "Property & Real Estate",
  "Family & Personal Law",
  "Constitutional Law",
  "Criminal Law",
  "Consumer & Insurance Matters",
  "Banking, Finance & Taxation",
  "Labour & Employment Law",
  "Intellectual Property Rights (IPR)",
  "Arbitration & ADR",
  "Government & Administrative Law",
  "Affidavits, Declarations & Notices",
  "Court Applications & Petitions",
];

const CreateDraft = () => {
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [content, setContent] = useState("");
  const [filtered, setFiltered] = useState([]);
  const config = { headers: { Authorization: `${token}` } };
  const toast = useToast();
  const editorRef = useRef(null);
  ///api/v1/draft/create_drafts
  const handleSubmit = async () => {
    try {
      const res = await axios.post(
        `${mod.api_url}/api/v1/draft/create_drafts`,
        {
          title,
          des: content,
          subTitle,
        },
        config
      );

      console.log("Response:", res.data);

      toast({
        title: "Draft submitted.",
        description: "Your draft was successfully posted.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      // Reset form
      setTitle("");
      setContent("");
      setSubTitle("");
    } catch (error) {
      console.error(
        "Error submitting draft:",
        error.response?.data || error.message
      );

      toast({
        title: "Submission failed.",
        description: "Something went wrong while posting the draft.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  const handleChange = (e) => {
    const value = e.target.value;
    setSubTitle(value);

    if (value.length > 0) {
      const results = draftTypes.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      );
      setFiltered(results);
    } else {
      setFiltered([]);
    }
  };

  const handleSelect = (value) => {
    setSubTitle(value);
    setFiltered([]);
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box mt="100px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={2}>
        <Box
          maxW="1000px"
          mx="auto"
          bg="white"
          p={6}
          borderRadius="md"
          boxShadow="md"
        >
          <Text fontSize="2xl" mb={4} bg="#D29B3F" p={3}>
            Add Sample Drafts Title
          </Text>

          <Input
            placeholder="Enter Title"
            mb={6}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <Box position="relative" width="300px">
            <Input
              placeholder="Types of draft"
              value={subTitle}
              onChange={handleChange}
              mb={2}
            />

            {filtered.length > 0 && (
              <Box
                position="absolute"
                width="100%"
                bg="white"
                boxShadow="md"
                borderRadius="md"
                zIndex="10"
                maxHeight="150px"
                overflowY="auto"
              >
                <List spacing={0}>
                  {filtered.map((item, index) => (
                    <ListItem
                      key={index}
                      px={4}
                      py={2}
                      cursor="pointer"
                      _hover={{ bg: "gray.100" }}
                      onClick={() => handleSelect(item)}
                    >
                      <Text>{item}</Text>
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
          </Box>

          <Text fontWeight="bold" mb={2}>
            Description
          </Text>
          <ReactQuill
            className="custom-quill"
            value={content}
            onChange={setContent}
            modules={modules}
            formats={formats}
            theme="snow"
            placeholder="Write your draft description here..."
            style={{ height: "60vh", marginBottom: "20px" }}
          />         

          <Flex justify="flex-end" mt={4} gap={4}>
            <Button
              variant="ghost"
              onClick={() => {
                setTitle("");
                setContent("");
              }}
            >
              Cancel
            </Button>
            <Button colorScheme="green" onClick={handleSubmit}>
              Submit
            </Button>
          </Flex>
        </Box>
      </Box>
    </>
  );
};

export default CreateDraft;
